/***********************************************************************************
 * FILE: subscriptionHome.js
 * DESC :
 *   [CSR-12235] 가전구독 홈(lgekor-mkt subscriptionHome.jsp) 전용 서버 연동 스크립트.
 *   subscription-ui-only/home.js는 UI 전용이라 카테고리 변경 시 커스텀 이벤트만 발생시키고
 *   (해당 파일 상단 "외부 데이터 연동 포인트" 주석 참고) 실제 서버 재조회는 하지 않는다.
 *   이 파일이 그 이벤트를 구독해서 GEO 영역별로 필요한 처리를 담당한다.
 *   - GEO 07 베스트랭킹: 서버에 재조회(ajax)해서 받은 카드 HTML로 교체
 *   - GEO 12 구독가이드: 전체 카테고리 콘텐츠가 최초 응답에 다 내려오므로 재조회 없이
 *     이미 그려진 카드를 카테고리 값으로 show/hide만 한다
 *   - GEO 11 상황별 여러 제품 추천: GEO 12와 동일하게 전체 상황(situation) 콘텐츠가 최초
 *     응답에 다 내려오므로 재조회 없이 상황 블록 전체를 카테고리 값으로 show/hide만 한다
 *   - GEO 13 자주 묻는 질문: 카테고리/페이지네이션 모두 서버에 재조회(ajax)해서 받은
 *     목록+페이지네이션 HTML로 교체 (페이지네이션 클릭은 home.js에 이벤트가 없어 직접 바인딩)
 *   - GEO 11 "장바구니 한번에 담기": home.js의 openDialog()는 팝업 UI만 열고 닫을 뿐 상품 데이터는
 *     다루지 않으므로(해당 파일 주석 참고), 여기서 클릭 시점에 화면에 보이는(is-hidden 아닌) 상황의
 *     상품 카드를 확인 팝업 목록에 채우고, "이대로 담기" 확정 시 모아둔 modelId/rtModelSeq를
 *     서버에 재조회(ajax)해서 장바구니에 담는다
 *
 *   [연동 이벤트] (subscription-ui-only/home.js가 발생, 두 번째 인자 { category: string })
 *     - careSolutions:bestRankingCategoryChange       → 구현 (GEO 07. 베스트랭킹, 서버 재조회)
 *     - careSolutions:subscriptionGuideCategoryChange → 구현 (GEO 12. 구독가이드, 클라이언트 필터)
 *     - careSolutions:personalizedRecommendationCategoryChange → 구현 (GEO 11. 상황별 여러 제품 추천, 클라이언트 필터)
 *     - careSolutions:faqCategoryChange                → 구현 (GEO 13. FAQ, 서버 재조회)
 *     - careSolutions:resubscribeCategoryChange
 *       → 미구현 (필요 시 추가)
 *
 *   [그 외 - 커스텀 이벤트 없이 직접 클릭 위임] home.js가 발생하는 커스텀 이벤트가 없는 영역은
 *   위 FAQ 페이지네이션(bindFaqPageClick)과 동일하게 여기서 클릭을 직접 위임으로 바인딩한다.
 *     - GEO 11 장바구니 담기(.careSolutions__personalized-recommendation-cart, .js-home-cart-confirm)
 *
 *   [주의]
 *   - ES5로 uglify되므로 ES6 문법 사용 금지(빌드: gulp jsCompile:caresolution)
 *   - 서버는 카드 HTML을 그대로 렌더링해서 내려주고, 이 파일은 교체/필터 후 Swiper
 *     재초기화만 담당한다(subscriptionHomeUI.reinitSwiper는 subscription-ui-only/home.js가
 *     노출하는 공개 메서드).
 ***********************************************************************************/
var subscriptionHomeCaresolution = (function() {
    var BEST_RANKING_AJAX_URL = '/care-solutions/retrieveBestRankingList.lgajax';
    var FAQ_AJAX_URL = '/care-solutions/retrieveFaqList.lgajax';
    var SITUATIONAL_CART_AJAX_URL = '/care-solutions/situationalRecommendationCart.lgajax';

    var selector = {
        bestRankingSection: '.js-home-best-ranking',
        bestRankingProductList: '.careSolutions__best-ranking-product-list',
        subscriptionGuideSection: '.js-home-subscription-guide',
        subscriptionGuideItem: '.careSolutions__subscription-guide-item',
        personalizedRecommendationSection: '.js-home-personalized-recommendation',
        personalizedRecommendationContent: '.js-home-personalized-recommendation-content',
        personalizedRecommendationCartButton: '.careSolutions__personalized-recommendation-cart',
        personalizedRecommendationProductCard: '.careSolutions__personalized-recommendation-product-card',
        personalizedRecommendationProductImage: '.careSolutions__personalized-recommendation-product-image',
        personalizedRecommendationProductName: '.careSolutions__personalized-recommendation-product-name',
        personalizedRecommendationProductBadges: '.careSolutions__personalized-recommendation-product-title-badges',
        personalizedRecommendationProductModel: '.careSolutions__personalized-recommendation-product-model',
        personalizedRecommendationProductMeta: '.careSolutions__personalized-recommendation-product-meta',
        cartDialogList: '.js-home-cart-dialog-list',
        cartConfirmButton: '.js-home-cart-confirm',
        cartToastSuccess: '.js-home-cart-toast-success',
        cartToastPartial: '.js-home-cart-toast-partial',
        faqSection: '.js-home-faq',
        faqResult: '.js-home-faq-result',
        faqPageButton: '.js-home-faq-page'
    };

    var HIDDEN_ITEM_STYLE_ID = 'subscriptionHomeCaresolutionHiddenItemStyle';

    /**
     * GEO 12/11. 카테고리 필터용 숨김 클래스를 <style> 태그로 직접 주입한다(care-solutions.scss는 건드리지 않음).
     * reinitSwiper가 Swiper를 destroy(true, true)로 재생성하는데, cleanStyles(2번째 true) 옵션 때문에
     * 슬라이드의 인라인 style 속성이 초기화되어 display:none을 인라인으로 주면 같이 지워진다.
     * class는 style 속성이 아니라서 영향을 받지 않으므로 클래스 기반으로 처리한다.
     */
    function ensureHiddenItemStyle() {
        if (document.getElementById(HIDDEN_ITEM_STYLE_ID)) {
            return;
        }

        var styleEl = document.createElement('style');
        styleEl.id = HIDDEN_ITEM_STYLE_ID;
        styleEl.appendChild(document.createTextNode(
            selector.subscriptionGuideItem + '.is-hidden { display: none !important; }' +
            selector.personalizedRecommendationContent + '.is-hidden { display: none !important; }'
        ));
        document.head.appendChild(styleEl);
    }

    /**
     * lg.common.js의 lgkorUI._addImgOnloadEvent()는 페이지 로드 시점에 존재하는 <img>에만
     * error 핸들러를 직접 바인딩(위임 아님)한다. ajax로 나중에 삽입된 <img>는 이 핸들러가 없어서
     * 실제 이미지가 깨져도 noimage.svg로 대체되지 않고 브라우저 기본 깨진 이미지 아이콘이 노출된다.
     * 같은 동작을 새로 삽입된 이미지에도 직접 걸어준다.
     */
    function applyImageErrorFallback(container) {
        var noImageSrc = (window.lgkorUI && window.lgkorUI.NO_IMAGE) || '/lg5-common/images/icons/noimage.svg';

        container.find('img').not('[data-pc-src]').on('error', function() {
            var img = this;
            img.onerror = null;
            if (!img.complete || !img.naturalWidth) {
                img.src = noImageSrc;
                img.classList.add('no-img');
            }
        });
    }

    /**
     * [GEO] G4 URL원칙: 칩이 실제 <a href="/care-solutions?rankingCategory=...">이므로,
     * ajax로 목록만 교체한 뒤에도 주소표시줄을 같은 쿼리 URL로 맞춰 둔다(새 히스토리를 쌓지 않도록 replaceState).
     * 북마크/공유/새로고침 시에도 컨트롤러가 이 쿼리파라미터로 동일한 결과를 SSR 할 수 있다.
     */
    function updateBestRankingUrl(category) {
        if (!window.history || typeof window.history.replaceState !== 'function') {
            return;
        }

        var url = category && category !== 'all'
            ? location.pathname + '?rankingCategory=' + encodeURIComponent(category)
            : location.pathname;

        window.history.replaceState(window.history.state, '', url);
    }

    /** GEO 07. 선택된 카테고리로 베스트랭킹 상품 리스트를 다시 조회해서 교체한다. */
    function fetchBestRankingByCategory(category) {
        var section = $(selector.bestRankingSection);
        var productList = section.find(selector.bestRankingProductList);

        if (!productList.length) {
            return;
        }

        $.ajax({
            url: BEST_RANKING_AJAX_URL,
            type: 'GET',
            data: { category: category },
            dataType: 'html',
            success: function(html) {
                productList.html(html);
                applyImageErrorFallback(productList);
                updateBestRankingUrl(category);

                if (window.subscriptionHomeUI && typeof window.subscriptionHomeUI.reinitSwiper === 'function') {
                    window.subscriptionHomeUI.reinitSwiper('js-home-best-ranking-products');
                }
            },
            error: function(xhr, status, error) {
                void 0;
                void 0;
                void 0;
            }
        });
    }

    /**
     * [GEO] G4 URL원칙 때문에 베스트랭킹 카테고리 칩을 실제 <a href="/care-solutions?rankingCategory=...">로
     * 렌더링한다(subscriptionHome.jsp). 이 칩의 활성화 토글/이벤트 트리거는 home.js가 이미 담당하고 있는데,
     * home.js는 이 화면 전용 파일이 아니라서 거기에 preventDefault를 추가하지 않고 여기서 별도로 가로챈다.
     * 같은 클릭 이벤트에 바인딩된 여러 핸들러 중 어느 하나라도 preventDefault를 호출하면 바인딩 순서와
     * 무관하게 기본 동작(페이지 이동)이 막히므로, home.js의 기존 로직과 독립적으로 동작해도 문제없다.
     * ctrl/cmd/shift-클릭, 가운데클릭(새 탭 열기)은 브라우저 기본 동작을 그대로 둔다.
     */
    function preventBestRankingCategoryLinkNavigation() {
        $(document).on('click', '.js-home-best-ranking-category', function(event) {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2) {
                return;
            }

            event.preventDefault();
        });
    }

    function bindBestRankingCategoryChange() {
        // [주의] 직접 바인딩(selector 고정 참조) 대신 document 위임 방식 사용
        // - jQuery 커스텀 이벤트는 trigger 시 상위로 버블링되므로 위임으로도 정상 수신 가능
        // - 바인딩 시점에 섹션 엘리먼트가 DOM에 존재해야 하는 제약이 없어짐
        $(document).on('careSolutions:bestRankingCategoryChange', selector.bestRankingSection, function(event, data) {
            var category = data && data.category;

            if (!category) {
                return;
            }

            fetchBestRankingByCategory(category);
        });
    }

    /** GEO 12. 선택된 카테고리에 해당하는 카드만 노출하고 나머지는 숨긴다(서버 재조회 없음). */
    function filterSubscriptionGuideByCategory(category) {
        var section = $(selector.subscriptionGuideSection);
        var items = section.find(selector.subscriptionGuideItem);

        if (!items.length) {
            return;
        }

        items.each(function() {
            var item = $(this);
            var itemCategory = item.data('subscriptionGuideItemCategory');
            var isVisible = category === 'all' || itemCategory === category;

            item.toggleClass('is-hidden', !isVisible);
        });

        if (window.subscriptionHomeUI && typeof window.subscriptionHomeUI.reinitSwiper === 'function') {
            window.subscriptionHomeUI.reinitSwiper('js-home-subscription-guide-swiper');
        }
    }

    function bindSubscriptionGuideCategoryChange() {
        // [주의] 직접 바인딩 대신 document 위임 방식 사용 (bindBestRankingCategoryChange 주석 참고)
        $(document).on('careSolutions:subscriptionGuideCategoryChange', selector.subscriptionGuideSection, function(event, data) {
            var category = data && data.category;

            if (!category) {
                return;
            }

            filterSubscriptionGuideByCategory(category);
        });
    }

    /**
     * GEO 11. 선택된 상황(situation)에 해당하는 콘텐츠 블록만 노출하고 나머지는 숨긴다(서버 재조회 없음).
     * GEO 12의 filterSubscriptionGuideByCategory와 동일한 패턴 - 전체 상황 콘텐츠가 최초 응답에
     * 이미 다 내려와 있으므로(JSP의 <c:forEach>), 여기서는 보여줄 블록만 클래스로 토글한다.
     */
    function filterPersonalizedRecommendationByCategory(category) {
        var section = $(selector.personalizedRecommendationSection);
        var contents = section.find(selector.personalizedRecommendationContent);

        if (!contents.length) {
            return;
        }

        contents.each(function() {
            var content = $(this);
            // [주의] data-personalized-recommendation-content 값이 displayObjectNo(순수 숫자 문자열)라
            // jQuery .data()가 Number로 자동 캐스팅한다. 클릭 핸들러는 .attr()로 읽어 문자열이라
            // 그대로 비교하면 타입이 달라 항상 불일치하므로 String()으로 맞춰서 비교한다.
            var contentCategory = String(content.data('personalizedRecommendationContent'));

            content.toggleClass('is-hidden', contentCategory !== String(category));
        });
    }

    function bindPersonalizedRecommendationCategoryChange() {
        // [주의] 직접 바인딩 대신 document 위임 방식 사용 (bindBestRankingCategoryChange 주석 참고)
        $(document).on('careSolutions:personalizedRecommendationCategoryChange', selector.personalizedRecommendationSection, function(event, data) {
            var category = data && data.category;

            if (!category) {
                return;
            }

            filterPersonalizedRecommendationByCategory(category);
        });
    }

    /**
     * GEO 11. 상품 카드(DOM) 하나를 읽어서 확인 팝업에 넣을 <li> 한 줄을 만든다.
     * 화면에 이미 그려져 있는 이미지/이름/모델명/뱃지/메타 텍스트를 그대로 복사해오는 것뿐이라
     * 별도 ajax 조회는 필요 없다.
     *
     * @param productCard 가전 1개를 나타내는 .careSolutions__personalized-recommendation-product-card 엘리먼트(jQuery로 감싼 것)
     * @return listItem: 팝업에 추가할 <li> 엘리먼트, modelId/rtModelSeq: 장바구니 담기 ajax에 쓸 상품 식별값
     */
    function buildCartDialogItem(productCard) {
        var imageUrl = productCard.find(selector.personalizedRecommendationProductImage).attr('src');
        var productName = productCard.find(selector.personalizedRecommendationProductName).text();
        var modelName = productCard.find(selector.personalizedRecommendationProductModel).text();
        var badgeList = productCard.find(selector.personalizedRecommendationProductBadges).children();

        // 계약기간/방문주기/케어유형 같은 메타 정보를, 퍼블 마크업(.careSolutions__dialog-cart-meta span + span)이
        // 구분선(|)을 그려주는 구조 그대로 <span> 각각으로 모아둔다(텍스트로 합치면 구분선이 사라진다).
        // 원본 상품 카드는 계약기간/방문주기가 <p> 하나 안에 <span> 2개로 같이 들어있으므로(subscriptionHome.jsp 참고),
        // <p> 단위가 아니라 <span> 단위로 쪼개야 계약기간/방문주기가 따로 분리된다.
        var metaLines = [];
        productCard.find(selector.personalizedRecommendationProductMeta).each(function() {
            var metaParagraph = $(this);
            var metaSpans = metaParagraph.children('span');
            if (metaSpans.length) {
                metaSpans.each(function() {
                    var spanText = $(this).text().trim();
                    if (spanText) {
                        metaLines.push(spanText);
                    }
                });
            } else {
                var paragraphText = metaParagraph.text().trim();
                if (paragraphText) {
                    metaLines.push(paragraphText);
                }
            }
        });

        // 케어서비스 세부 내용(svcServiceText)은 상품 카드에는 노출하지 않고 이 확인 팝업에서만 보여준다.
        // 카드 DOM에도 글자로 찍혀 있지 않으므로(data 속성으로만 보관), 계약기간/방문주기 등과 같은 줄로 섞이지
        // 않게 별도 <p>로 분리해서 붙인다.
        var svcServiceText = productCard.data('svcServiceText');

        // 빈 틀을 먼저 만들고, 그 안의 각 자리(이미지/이름/모델명/메타)를 채워 넣는다
        var listItem = $(
            '<li class="careSolutions__dialog-cart-item">' +
                '<span class="careSolutions__dialog-cart-media" aria-hidden="true"><img alt="" loading="lazy" decoding="async" /></span>' +
                '<div class="careSolutions__dialog-cart-info">' +
                    '<strong class="careSolutions__dialog-cart-name"><span class="careSolutions__dialog-cart-product-name"></span></strong>' +
                    '<span class="careSolutions__dialog-cart-model"></span>' +
                '</div>' +
                '<p class="careSolutions__dialog-cart-meta"></p>' +
                '<p class="careSolutions__dialog-cart-quantity">수량 1개</p>' +
            '</li>'
        );

        listItem.find('.careSolutions__dialog-cart-media img').attr('src', imageUrl);
        listItem.find('.careSolutions__dialog-cart-product-name').text(productName);
        listItem.find('.careSolutions__dialog-cart-model').text(modelName);
        var metaContainer = listItem.find('.careSolutions__dialog-cart-meta');
        $.each(metaLines, function(index, line) {
            metaContainer.append($('<span></span>').text(line));
        });

        if (svcServiceText) {
            $('<p class="careSolutions__dialog-cart-meta careSolutions__dialog-cart-meta--separate"></p>')
                .text(svcServiceText)
                .insertAfter(metaContainer);
        }

        if (badgeList.length) {
            listItem.find('.careSolutions__dialog-cart-name').append(
                $('<span class="careSolutions__dialog-cart-title-badges"></span>').append(badgeList.clone())
            );
        }

        return {
            listItem: listItem,
            modelId: productCard.data('modelId'),
            rtModelSeq: productCard.data('rtModelSeq')
        };
    }

    /**
     * GEO 11. "장바구니 한번에 담기" 버튼을 누르면 지금 화면에 보이는(is-hidden 아닌) 상황 탭의
     * 상품 카드들을 확인 팝업 목록(selector.cartDialogList)에 채워 넣는다.
     *
     * [주의] 팝업을 여는 것 자체는 이 함수가 하지 않는다. home.js의 openDialog() 클릭 핸들러가
     * 따로(먼저 또는 나중에, 순서는 상관없음) 바인딩되어 다이얼로그를 열어준다. 이 함수는 그 팝업
     * 안의 목록(리스트)만 채우는 역할이다.
     *
     * 채워 넣은 뒤에는 각 상품의 modelId/rtModelSeq를 배열로 모아 cartDialogList 엘리먼트에
     * jQuery data로 저장해둔다. 이렇게 저장해두는 이유는, 뒤에서 "이대로 담기" 버튼을 누르는 시점에
     * (submitSituationalRecommendationCart) 다시 DOM을 뒤지지 않고 바로 꺼내 쓰기 위해서다.
     *
     * @param cartButton 클릭된 "장바구니 한번에 담기" 버튼(jQuery로 감싼 것)
     */
    function fillCartDialogPreview(cartButton) {
        var activeContent = cartButton.closest(selector.personalizedRecommendationContent);
        var dialogList = $(selector.cartDialogList);

        if (!activeContent.length || !dialogList.length) {
            return;
        }

        dialogList.empty();

        var cartItems = [];

        activeContent.find(selector.personalizedRecommendationProductCard).each(function() {
            var cardInfo = buildCartDialogItem($(this));

            dialogList.append(cardInfo.listItem);

            if (cardInfo.modelId && cardInfo.rtModelSeq) {
                cartItems.push({
                    modelId: String(cardInfo.modelId),
                    rtModelSeq: String(cardInfo.rtModelSeq)
                });
            }
        });

        dialogList.data('cartItems', cartItems);
    }

    function bindCartButtonClick() {
        $(document).on('click', selector.personalizedRecommendationCartButton, function() {
            fillCartDialogPreview($(this));
        });
    }

    /**
     * GEO 11. 확인 팝업의 "이대로 담기" 버튼을 누르면, fillCartDialogPreview()가 미리 모아둔
     * cartItems(상품별 modelId/rtModelSeq 목록)를 서버로 보내서 실제 장바구니에 담는다.
     *
     * [주의] 팝업을 닫는 것은 이 함수가 하지 않는다. home.js에 이미 .js-home-cart-confirm 클릭 시
     * 다이얼로그를 닫는 핸들러가 따로 있다. 이 함수는 그 핸들러와 별개로 같은 버튼에 추가로
     * 바인딩되어, 팝업이 닫히는 것과 상관없이 ajax 요청과 결과 토스트 표시만 담당한다.
     */
    function submitSituationalRecommendationCart() {
        var cartItems = $(selector.cartDialogList).data('cartItems') || [];

        // 담을 상품이 하나도 없으면(예: 데이터 이상) 요청 자체를 보내지 않는다
        if (!cartItems.length) {
            return;
        }

        var successToast = $(selector.cartToastSuccess);
        var partialToast = $(selector.cartToastPartial);

        // 이전에 띄웠던 토스트가 남아있을 수 있으니 요청 전에 둘 다 숨긴다
        successToast.add(partialToast).attr('hidden', 'hidden');

        $.ajax({
            url: SITUATIONAL_CART_AJAX_URL,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(cartItems)
        }).done(function(response) {
            var isSuccess = response && response.status === 'success';
            var toastToShow = isSuccess ? successToast : partialToast;
            toastToShow.removeAttr('hidden');
        }).fail(function() {
            // 네트워크 오류 등으로 서버 응답 자체를 못 받은 경우도 "일부 실패" 토스트로 안내한다
            partialToast.removeAttr('hidden');
        });
    }

    function bindCartConfirmClick() {
        $(document).on('click', selector.cartConfirmButton, function() {
            submitSituationalRecommendationCart();
        });
    }

    /** GEO 13. 선택된 카테고리/페이지로 FAQ 목록+페이지네이션을 다시 조회해서 교체한다. */
    function fetchFaqList(category, page) {
        var section = $(selector.faqSection);
        var result = section.find(selector.faqResult);

        if (!result.length) {
            return;
        }

        $.ajax({
            url: FAQ_AJAX_URL,
            type: 'GET',
            data: { category: category, page: page },
            dataType: 'html',
            success: function(html) {
                result.html(html);
            },
            error: function(xhr, status, error) {
                void 0;
                void 0;
                void 0;
            }
        });
    }

    function bindFaqCategoryChange() {
        // [주의] 직접 바인딩 대신 document 위임 방식 사용 (bindBestRankingCategoryChange 주석 참고)
        $(document).on('careSolutions:faqCategoryChange', selector.faqSection, function(event, data) {
            var category = data && data.category;

            if (!category) {
                return;
            }

            // 카테고리를 바꾸면 페이지는 항상 첫 페이지로 초기화
            fetchFaqList(category, 0);
        });
    }

    /** GEO 13. 페이지네이션은 home.js에 대응 이벤트가 없어 클릭을 직접 위임으로 바인딩한다. */
    function bindFaqPageClick() {
        $(document).on('click', selector.faqSection + ' ' + selector.faqPageButton, function() {
            var pageButton = $(this);

            if (pageButton.prop('disabled')) {
                return;
            }

            var page = parseInt(pageButton.attr('data-faq-page'), 10);

            if (isNaN(page) || page < 0) {
                return;
            }

            var category = $(selector.faqSection).attr('data-active-category') || 'CONTRACT';
            fetchFaqList(category, page);
        });
    }

    function init() {
        ensureHiddenItemStyle();
        preventBestRankingCategoryLinkNavigation();
        bindBestRankingCategoryChange();
        bindSubscriptionGuideCategoryChange();
        bindPersonalizedRecommendationCategoryChange();
        bindCartButtonClick();
        bindCartConfirmClick();
        bindFaqCategoryChange();
        bindFaqPageClick();
    }

    return {
        init: init
    };
})();

$(function() {
    subscriptionHomeCaresolution.init();
});
